import apiMap from '../../apis/apiMap.mjs'
import parseMap from '../../scripts/parseMap.mjs'
import readProject from '../readProject.mjs'

export default pkid => {
    return async () => {
        const mapData = await apiMap.read({pkid})
        const initData = parseMap(mapData)
        const {prjId, sVer} = initData.data
        const project = await readProject(prjId, sVer)
        Object.assign(initData.data, project)
        return initData
    }
}
